import http from './request'


// 获取图片验证码
export const getCode_api = data => {
    return http({
        method: "post",
        url: '/api/oauth/captcha',
        data
    })
}

//登陆
export const login_api = data => {
    return http({
        method: "post",
        url: '/api/oauth/token',
        data
    })
}

//获取账号类型
export const accountType_api = data => {
    return http({
        method: "post",
        url: '/api/account/type',
        data
    })
}

//获取账号信息
export const accountInfo_api = data => {
    return http({
        method: "post",
        url: '/api/account/info',
        data
    })
}


//获取课程列表
export const courseList_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/course/list',
        data
    })
}

//获取课程列表
export const courseCategory_api = data => {
    return http({
        method: "post",
        url: 'api/simulation/course/category',
        data
    })
}

//课程添加任务
export const createTask_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/task/create',
        data
    })
}

//班级列表
export const classList_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/class/list',
        data
    })
}

//课程详情
export const courseShow_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/course/show',
        data
    })
}

//任务列表
export const taskList_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/task/list',
        data
    })
}


//删除任务
export const taskDelete_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/task/delete',
        data
    })
}

//任务成绩列表
export const taskScore_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/task/score',
        data
    })
}

//任务成绩详情
export const taskScoreShow_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/task/score_show',
        data
    })
}


//课程学习记录
export const courseStudied_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/course/studied',
        data
    })
}


//根据仿真班级ID获取学生列表
export const studentList_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/student/list',
        data
    })
}

//删除班级
export const classDelete_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/class/delete',
        data
    })
}

//所有学生列表
export const studentSelect_api = data => {
    return http({
        method: "post",
        url: '/api/student/select',
        data
    })
}

//班级添加学生
export const studentAdd_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/class/student/add',
        data
    })
}

//学校班级列表
export const classSelect_api = data => {
    return http({
        method: "post",
        url: '/api/class/select',
        data
    })
}

//添加班级
export const classCreate_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/class/create',
        data
    })
}

//学生课程列表
export const studentCourse_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/student/course',
        data
    })
}

//仿真实训任务清单
export const studentTask_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/student/task',
        data
    })
}

//学生 任务课程列表
export const studentTask_course_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/student/task_course',
        data
    })
}


//根据任务ID获取任务详情
export const taskShow_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/task/show',
        data
    })
}

//根据任务ID修改任务内容
export const taskUpdate_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/task/update',
        data
    })
}



//根据ID获取班级详情
export const classShow_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/class/show',
        data
    })
}



//根据ID修改班级信息
export const classUpdate_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/class/update',
        data
    })
}

//修改密码
export const accountUpdate_api = data => {
    return http({
        method: "post",
        url: '/api/account/update',
        data
    })
}

//课程成绩详情
export const scoreShow_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/course/score_show',
        data
    })
}

// 根据ID修改任务成绩
export const score_update_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/task/score_update',
        data
    })
}

// 导出成绩
export const score_export_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/task/score_export',
        data
    })
}


// 学生端获取任务
export const owner_task_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/student/owner_task',
        data
    })
}

//获取title
export const getTitle_api = data => {
    return http({
        method: "post",
        url: '/api/config',
        data
    })
}

//获取课程详情(按钮)
export const courseShowBtn_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/course/show',
        data
    })
}

//课程评星
export const evaluate_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/course/evaluate',
        data
    })
}

//获取课程评星列表
export const getEvaluateList_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/course/evaluate_list',
        data
    })
}

//删除课程评星
export const evaluateDelete_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/course/evaluate_delete',
        data
    })
}

//删除课程评价
export const commentDelete_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/course/comment_delete',
        data
    })
}

//课程评价
export const comment_store_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/course/comment_store',
        data
    })
}

//获取课程评价列表
export const comment_list_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/course/comment_list',
        data
    })
}

//添加实验总结
export const addSummary_api = data => {
    return http({
        method: "post",
        url: '/api/simulation/course/summary',
        data
    })
}
//token 登陆
export const tokenLogin = data => {
  return http({
      method: "get",
      url: '/api/oauth/token_login?access_token='+data.access_token,
  })
}



// WEBPACK FOOTER //
// ./src/http/api.js